module.exports = __webpack_public_path__ + "static/kaja-kujawa-medinvest-new-93b73526ca6eb4405ce66ea6439408d4.jpg";